import { TextStyleModel } from '../../../../Common/PageBuilder/models/text-style.model';
import { ImageStyleModel } from '../../../../Common/PageBuilder/models/image-style.model';
import { DividerStyleModel } from '../../../../Common/PageBuilder/models/divider-style.model';
import { ButtonStyleModel } from '../../../../Common/PageBuilder/models/button-style.model';
import { GenericStyleModel } from '../../../../Common/Styles/models/generic-style.model';
import { DistributionBlockTypeEnum } from '../../enums/distribution-block-type.enum';
import { SocialLinkStyleModel } from '../../../../Common/PageBuilder/models/link-style.model';
import { LayoutStyle } from '../../../../Common/PageBuilder/models/layout-style.model';
import { LayoutBlockDisplayRatiosEnum } from '../../../../Common/PageBuilder/enums/layout-block-display-ratios.enum';

export class DistributionGeneralStylesModel {
    distributionMaxWidthPx: number;
    [DistributionBlockTypeEnum.text]: TextStyleModel;
    [DistributionBlockTypeEnum.title]: TextStyleModel;
    [DistributionBlockTypeEnum.image]: ImageStyleModel;
    [DistributionBlockTypeEnum.divider]: DividerStyleModel;
    [DistributionBlockTypeEnum.button]: ButtonStyleModel;
    [DistributionBlockTypeEnum.link]: SocialLinkStyleModel;
    [DistributionBlockTypeEnum.oneColumnLayout]: LayoutStyle;
    [DistributionBlockTypeEnum.twoColumnLayout]: LayoutStyle;
    [DistributionBlockTypeEnum.threeColumnLayout]: LayoutStyle;

    constructor(apiModel?: any) {
        if (typeof apiModel === 'string' && apiModel !== '') {
            apiModel = JSON.parse(apiModel);
        }

        this.setStyles(apiModel);

        if (this.distributionMaxWidthPx === undefined) {
            this.distributionMaxWidthPx = 640;
        }

        if (!this[DistributionBlockTypeEnum.text]) {
            this[DistributionBlockTypeEnum.text] = new TextStyleModel();
        }

        if (!this[DistributionBlockTypeEnum.title]) {
            this[DistributionBlockTypeEnum.title] = new TextStyleModel();
        }

        if (!this[DistributionBlockTypeEnum.image]) {
            this[DistributionBlockTypeEnum.image] = new ImageStyleModel();
        }

        if (!this[DistributionBlockTypeEnum.divider]) {
            this[DistributionBlockTypeEnum.divider] = new DividerStyleModel();
        }

        if (!this[DistributionBlockTypeEnum.button]) {
            this[DistributionBlockTypeEnum.button] = new ButtonStyleModel();
        }

        if (!this[DistributionBlockTypeEnum.link]) {
            this[DistributionBlockTypeEnum.link] = new SocialLinkStyleModel();
        }

        if (!this[DistributionBlockTypeEnum.oneColumnLayout]) {
            this[DistributionBlockTypeEnum.oneColumnLayout] = new LayoutStyle();
        }

        if (!this[DistributionBlockTypeEnum.twoColumnLayout]) {
            this[DistributionBlockTypeEnum.twoColumnLayout] = new LayoutStyle({ displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE });
        }

        if (!this[DistributionBlockTypeEnum.threeColumnLayout]) {
            this[DistributionBlockTypeEnum.threeColumnLayout] = new LayoutStyle({ displayRatio: LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE });
        }
    }

    public toApi(): any {
        return {
            distributionMaxWidthPx: this.distributionMaxWidthPx,
            [DistributionBlockTypeEnum.text]: this[DistributionBlockTypeEnum.text].toBlockStyle(),
            [DistributionBlockTypeEnum.title]: this[DistributionBlockTypeEnum.title].toBlockStyle(),
            [DistributionBlockTypeEnum.image]: this[DistributionBlockTypeEnum.image].toBlockStyle(),
            [DistributionBlockTypeEnum.divider]: this[DistributionBlockTypeEnum.divider].toBlockStyle(),
            [DistributionBlockTypeEnum.button]: this[DistributionBlockTypeEnum.button].toBlockStyle(),
            [DistributionBlockTypeEnum.link]: this[DistributionBlockTypeEnum.link].toBlockStyle(),
            [DistributionBlockTypeEnum.oneColumnLayout]: this[DistributionBlockTypeEnum.oneColumnLayout].toBlockStyle(),
            [DistributionBlockTypeEnum.twoColumnLayout]: this[DistributionBlockTypeEnum.twoColumnLayout].toBlockStyle(),
            [DistributionBlockTypeEnum.threeColumnLayout]: this[DistributionBlockTypeEnum.threeColumnLayout].toBlockStyle()
        };
    }

    public setStyles(styles: any): void {
        if (styles) {
            if (styles.hasOwnProperty('distributionMaxWidthPx')) {
                this.distributionMaxWidthPx = styles.distributionMaxWidthPx;
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.text)) {
                this[DistributionBlockTypeEnum.text] = new TextStyleModel(styles[DistributionBlockTypeEnum.text]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.title)) {
                this[DistributionBlockTypeEnum.title] = new TextStyleModel(styles[DistributionBlockTypeEnum.title]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.image)) {
                this[DistributionBlockTypeEnum.image] = new ImageStyleModel(styles[DistributionBlockTypeEnum.image]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.divider)) {
                this[DistributionBlockTypeEnum.divider] = new DividerStyleModel(styles[DistributionBlockTypeEnum.divider]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.button)) {
                this[DistributionBlockTypeEnum.button] = new ButtonStyleModel(styles[DistributionBlockTypeEnum.button]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.link)) {
                this[DistributionBlockTypeEnum.link] = new SocialLinkStyleModel(styles[DistributionBlockTypeEnum.link]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.oneColumnLayout)) {
                this[DistributionBlockTypeEnum.oneColumnLayout] = new LayoutStyle(styles[DistributionBlockTypeEnum.oneColumnLayout]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.twoColumnLayout)) {
                this[DistributionBlockTypeEnum.twoColumnLayout] = new LayoutStyle(styles[DistributionBlockTypeEnum.twoColumnLayout]);
            }
            if (styles.hasOwnProperty(DistributionBlockTypeEnum.threeColumnLayout)) {
                this[DistributionBlockTypeEnum.threeColumnLayout] = new LayoutStyle(styles[DistributionBlockTypeEnum.threeColumnLayout]);
            }
        }
    }

    public getStyles(): GenericStyleModel[] {
        return [
            this[DistributionBlockTypeEnum.text],
            this[DistributionBlockTypeEnum.title],
            this[DistributionBlockTypeEnum.image],
            this[DistributionBlockTypeEnum.divider],
            this[DistributionBlockTypeEnum.button],
            this[DistributionBlockTypeEnum.link],
            this[DistributionBlockTypeEnum.oneColumnLayout],
            this[DistributionBlockTypeEnum.twoColumnLayout],
            this[DistributionBlockTypeEnum.threeColumnLayout]
        ];
    }

    public setProperty(property: string, value: any): void {
        const parts = property.split('.');
        let obj: any = this;
        for (let i = 0, l = parts.length; i < l - 1; i++) {
            obj = obj[parts[i]];
        }
        obj[parts[parts.length - 1]] = value;
    }

    public equals(other: DistributionGeneralStylesModel): boolean {
        if (other === null || other === undefined) {
            return false;
        }
        if (this.distributionMaxWidthPx !== other.distributionMaxWidthPx) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.text].equals(other[DistributionBlockTypeEnum.text], false)) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.title].equals(other[DistributionBlockTypeEnum.title], false)) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.image].equals(other[DistributionBlockTypeEnum.image])) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.divider].equals(other[DistributionBlockTypeEnum.divider])) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.button].equals(other[DistributionBlockTypeEnum.button], false)) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.link].equals(other[DistributionBlockTypeEnum.link], false)) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.oneColumnLayout].equals(other[DistributionBlockTypeEnum.oneColumnLayout], false)) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.twoColumnLayout].equals(other[DistributionBlockTypeEnum.twoColumnLayout], false)) {
            return false;
        }
        if (!this[DistributionBlockTypeEnum.threeColumnLayout].equals(other[DistributionBlockTypeEnum.threeColumnLayout], false)) {
            return false;
        }
        return true;
    }
}
